<script setup lang="ts">
import type { PartsTreeNode } from "@/types/diagnostics.types";

defineProps<{
  parts: PartsTreeNode[];
  level?: number;
}>();
</script>

<template>
  <ul class="parts-preview-list">
    <li v-for="part in parts" :key="part.name" class="parts-preview-item">
      <div class="part-row" :style="{ marginLeft: (level || 0) * 20 + 'px' }">
        <span class="part-name">{{ part.name }}</span>
      </div>
      <div class="part-children">
        <PartsTreePreview
          v-if="part.children?.length"
          :parts="part.children"
          :level="(level || 0) + 1"
        />
      </div>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.parts-preview-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.parts-preview-item {
  margin-bottom: 4px;
}

.part-row {
  padding: 12px 14px;
  border-radius: 8px;
}

.part-name {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
}

.part-children {
  margin-top: 4px;
  border-left: 2px solid #e0e0e0;
}
</style>
